export default "__VITE_ASSET__9d4e2c8c__"